import { Component } from 'react';

import { bugsnagError } from 'services/bugsnag';

const TATARI_MODSY_TOKEN = 'b55bc248-6f51-40e2-8790-fb3eeb8f4032';

export default class TatariProviderHOC extends Component {
  state = {
    tatariLoaded: false,
    userEmail: null
  };
  componentDidMount () {
    const { authData, enabled, windowLoaded } = this.props;
    const { tatariLoaded } = this.state;

    // keep static var of enabled so we don't run static methods when not enabled
    TatariProviderHOC.enabled = enabled;

    // wait until window is loaded to load Tatari
    if (windowLoaded && enabled && !tatariLoaded) { this.loadTatariJS(authData); }
  }

  componentDidUpdate (prevProps) {
    const { authData, enabled, windowLoaded } = this.props;
    const { tatariLoaded } = this.state;

    // if we didn't load in componentDidMount, do it now
    if (!tatariLoaded && windowLoaded && !prevProps.windowLoaded && enabled) {
      this.loadTatariJS(authData);
    }

    // if user becomes authenticated or the user changes, re-push authentication data
    const userAuthChanged = (!prevProps.authData && authData);
    const userEmailChanged = (prevProps.authData && authData && (prevProps.authData.email !== authData.email));
    if (enabled &&
        (userAuthChanged || userEmailChanged)
    ) {
      this.userAuthenticated(this.props.authData);
    }
  }

  loadTatariJS = (authData) => {
    // shouldn't be possible but if we somehow get here when Tatari is already loaded then bail
    if (this.state.tatariLoaded || window.tatari) { return; }

    try {
      let script = document.createElement('script');
      script.textContent = `
!function() {
  try {
    !function(t,n) {
      if(!n.version) {
        window.tatari=n,
        n.init=function(t,e) {
          var i=function(t,e) {
            n[e]=function() {
              t.push([e].concat(Array.prototype.slice.call(arguments,0)));
            }
          };
          "track pageview identify".split(" ").forEach(function(t) {
            i(n,t);
          }),
          n._i=t,
          n.pageview();
        },
        n.version="latest";
        var e=t.createElement("script");
        e.type="text/javascript",
        e.async=!0,
        e.src="https://d2hrivdxn8ekm8.cloudfront.net/tracker-latest.min.js";
        e.onload = () => {
          console.log('Tatari tracker Loaded');
        }
        var i=t.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(e,i);
      }
    }(document,window.tatari||[]);
  } catch(t) {
    console.log(t);
  }
}();
tatari.init('${(process.env.REACT_APP_ENV === 'prod') ? TATARI_MODSY_TOKEN : 'modsy-testing'}');
console.log('Tatari Initialized');
      `;

      // identify the user if they are already authenticated
      if (authData && authData.userId) {
        script.textContent += `tatari.identify('${authData.userId}');`;
      }

      // Add the script to head
      document.head.appendChild(script);
    } catch (exception) {
      bugsnagError(new Error(`Exception encountered when trying to load Tatari: ${exception}`));
    }
  }

  userAuthenticated = (authData) => {
    // don't identify if Tatari isn't enabled or there's no authData to identify with
    // or if it hasn't loaded yet, we will identify when it loads as well
    if (!TatariProviderHOC.enabled || !authData || !window.tatari) { return; }

    // Tatari needs a unique identifier per-user
    window.tatari.identify(authData.userId);
  }

  render () {
    return this.props.children;
  }
}

// Track events using window.tatari.track(name, detail)
// here is an example:
// window.tatari.track('purchase', { orderId: 12144251, total: 104.20, checkoutMethod: "Paypal" });
export const trackEvent = (name, data) => {
  if (!TatariProviderHOC.enabled || !window.tatari || !name) { return; }

  window.tatari.track(name, JSON.stringify(data));
};

// NOTE: pageviews are already tracked, there is a method for tracking them but
// it shouldn't be necessary
